import { ThumbType } from '~/shared/api'
import { buildI18nMessage } from '~/shared/lib/i18n'
import { sanitizeNumber } from '~/shared/lib/utils'

const MAXIMUM_EXCEEDING_RUN = 50000
const MINIMAL_NUMBER_PHOTOS_CARS = 9

export const validateMileage = (
  mileage?: number,
  lastInspectionMileage?: number,
): string => {
  const sanitizedMileage = sanitizeNumber(mileage || 0)

  if (!lastInspectionMileage) {
    return ''
  }

  const lastMileageStr = lastInspectionMileage.toLocaleString()

  if (sanitizedMileage < lastInspectionMileage) {
    return buildI18nMessage(
      'validate.mileage cannot be less than lastMileage km from the previous inspection!',
      { lastMileage: lastMileageStr },
    )
  }

  if (sanitizedMileage > lastInspectionMileage + MAXIMUM_EXCEEDING_RUN) {
    return buildI18nMessage(
      'validate.mileage cannot be more than 50,000 km greater than lastMileage km from the last inspection!',
      { lastMileage: lastMileageStr },
    )
  }

  return ''
}

export const validateCarPhotos = (
  needValidated: boolean,
  carPhotos?: ThumbType[],
) => {
  if (!needValidated) return

  return (carPhotos?.length || 0) < MINIMAL_NUMBER_PHOTOS_CARS
}
